import React from 'react';


var Loading = (props) => {
	let { text } = props;
	text = text || `Wir suchen die beste Unterkunft für sie!`;

	return (
		<div className="loading">
			<div className="spinner">
			  <div className="bounce1"></div>
			  <div className="bounce2"></div>
			  <div className="bounce3"></div>
			</div>
			<p>{text}</p>
		</div>
	);
}

export default Loading;



/** WEBPACK FOOTER **
 ** ../ibe/components/Loading.js
 **/